export const HR_WHATSAPP_NUMBER = "919936120357";
export const HR_WHATSAPP_DISPLAY = "+91 99361 20357";

export const hrWaLink = (msg = "Hi! I'd like to apply for a career opportunity at Stationery Wala.") =>
  `https://wa.me/${HR_WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const WHATSAPP_NUMBER = "919125352918";
export const WHATSAPP_DISPLAY = "+91 91253 52918";
export const CONTACT_EMAIL = "stationerywala1@gmail.com";
export const INSTAGRAM_HANDLE = "stationery_wala__";
export const INSTAGRAM_URL = "https://www.instagram.com/stationery_wala__/";
export const SISTER_BRAND = {
  name: "Invitation Wala",
  url: "https://www.invitationwala.online",
  domain: "invitationwala.online",
  instagram: "https://www.instagram.com/invitation_wala__/",
  instagramHandle: "invitation_wala__",
  tagline: "Digital wedding invitations · GIFs, videos & e-invites",
};

export const FEATURED_PARTNERS = [
  { id: "weddingsutra", name: "WeddingSutra", url: "https://www.weddingsutra.com/" },
  { id: "weddingbazaar", name: "Wedding Bazaar", url: "https://www.weddingbazaar.com/" },
];
export const OFFICE_ADDRESS = {
  line1: "A1514c, Spectrum Mall",
  line2: "Sector 75, Noida",
  region: "Uttar Pradesh, India",
  full: "A1514c, Spectrum Mall, Sector 75, Noida, UP, India",
  mapUrl: "https://share.google/erOGyw5Of4LhbSgam",
};

export const waLink = (msg = "Hi Stationery Wala, I'd like a custom quote.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const IMAGES = {
  hero: "/images/portfolio/luxury-wedding-invitation-fan.webp",
  luggageTags: "/images/portfolio/destination-wedding-luggage-tags.webp",
  caricatureTags: "/images/portfolio/caricature-wedding-luggage-tags.webp",
  hamperTags: "/images/portfolio/watercolour-wedding-invitation-suite.webp",
  tentCards: "/images/portfolio/wedding-welcome-fan-rainbow.webp",
  // legacy aliases (kept for components that still reference them)
  wedding: "/images/portfolio/destination-wedding-luggage-tags.webp",
  packaging: "/images/portfolio/wedding-invitation-box-carriage.webp",
  hampers: "/images/portfolio/caricature-wedding-luggage-tags.webp",
  itinerary: "/images/portfolio/wedding-itinerary-card-illustrated.webp",
  fan: "/images/portfolio/wedding-welcome-fan-rainbow.webp",
  process: "/images/portfolio/watercolour-wedding-invitation-suite.webp",
};

// Primary bento (first 5) — the "featured" pieces on the Home Lookbook
export const PORTFOLIO = [
  {
    id: "cutout-itinerary",
    img: "/images/portfolio/couple-cutout-wedding-itinerary.webp",
    title: "Cutout Itinerary",
    cat: "Wedding · Couple Cutouts",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    id: "luggage-tags",
    img: "/images/portfolio/destination-wedding-luggage-tags.webp",
    title: "Luggage Tags",
    cat: "Hospitality · Custom Shapes",
    span: "md:col-span-5",
  },
  {
    id: "watercolor-invite",
    img: "/images/portfolio/watercolour-wedding-invitation-suite.webp",
    title: "Vienna Watercolour Suite",
    cat: "Wedding · Destination",
    span: "md:col-span-5",
  },
  {
    id: "card-fan",
    img: "/images/portfolio/luxury-wedding-invitation-fan.webp",
    title: "The Fan Series",
    cat: "Wedding · Pink Florals",
    span: "md:col-span-7",
  },
  {
    id: "carriage-box",
    img: "/images/portfolio/premium-wedding-stationery-suite.webp",
    title: "The Ultimate Wedding Suite",
    cat: "Complete Collection · 13 Pieces",
    span: "md:col-span-12",
  },
];

// Extended carousel — revealed via "Show more" button
export const PORTFOLIO_EXTENDED = [
  {
    id: "ultimate-collage",
    img: "/images/portfolio/complete-wedding-stationery-collection.webp",
    title: "The Ultimate Wedding Suite",
    cat: "Complete Collection",
  },
  {
    id: "petal-cones",
    img: "/images/portfolio/monogrammed-petal-toss-cones.webp",
    title: "Rose Petal Toss Cones",
    cat: "Ceremony · Monogrammed",
  },
  {
    id: "welcome-itinerary",
    img: "/images/portfolio/destination-wedding-welcome-card.webp",
    title: "Welcome & Itinerary Card",
    cat: "Destination Wedding",
  },
  {
    id: "suitcase-ornament-set",
    img: "/images/portfolio/caricature-wedding-luggage-tags.webp",
    title: "Couple Suitcase Ornaments",
    cat: "Travel Wedding · Die-Cut Set",
  },
  {
    id: "rainbow-welcome-fan",
    img: "/images/portfolio/wedding-welcome-fan-rainbow.webp",
    title: "Rainbow Welcome Fan",
    cat: "Udaipur · 3-Day Celebration",
  },
  {
    id: "heirloom-fan",
    img: "/images/portfolio/luxury-wedding-invitation-fan.webp",
    title: "The Heirloom Fan",
    cat: "Floral · Hand-Assembled",
  },
  {
    id: "luggage-tag-set",
    img: "/images/portfolio/destination-wedding-luggage-tags.webp",
    title: "Destination Luggage Tags",
    cat: "Hospitality · Set of 4",
  },
  {
    id: "atelier-itinerary",
    img: "/images/portfolio/watercolour-wedding-invitation-suite.webp",
    title: "Atelier Watercolour Series",
    cat: "Vienna · Garden Florals",
  },
  {
    id: "vivek-nupur-set",
    img: "/images/portfolio/lotus-wedding-welcome-suite.webp",
    title: "Lotus Welcome Suite",
    cat: "Udaipur Wedding · Custom Monogram",
  },
  {
    id: "kochar-welcome",
    img: "/images/portfolio/wedding-itinerary-editorial-fold.webp",
    title: "The Kochar Itinerary",
    cat: "Editorial Fold · Candlelit",
  },
  {
    id: "wedding-timeline",
    img: "/images/portfolio/wedding-itinerary-card-illustrated.webp",
    title: "Illustrated Wedding Timeline",
    cat: "Multi-day · Hand-Illustrated",
  },
  {
    id: "magenta-suite",
    img: "/images/portfolio/royal-indian-wedding-invitation-suite.webp",
    title: "The Magenta Heritage Suite",
    cat: "Royal · Die-Cut Cards",
  },
];

// Categorized portfolio for the dedicated /portfolio gallery page
export const PORTFOLIO_BY_CATEGORY = {
  "Indian Wedding Cards": [
    { id: "fan-series", img: "/images/portfolio/luxury-wedding-invitation-fan.webp", title: "The Heirloom Fan Series" },
    { id: "magenta-suite-cat", img: "/images/portfolio/royal-indian-wedding-invitation-suite.webp", title: "Magenta Heritage Suite" },
    { id: "watercolor-vienna", img: "/images/portfolio/watercolour-wedding-invitation-suite.webp", title: "Atelier Watercolour Suite" },
    { id: "ultimate-collection", img: "/images/portfolio/premium-wedding-stationery-suite.webp", title: "The Ultimate Wedding Suite" },
  ],
  "Destination & NRI Invitations": [
    { id: "rainbow-fan", img: "/images/portfolio/wedding-welcome-fan-rainbow.webp", title: "Udaipur Rainbow Welcome Fan" },
    { id: "kochar-welcome-cat", img: "/images/portfolio/wedding-itinerary-editorial-fold.webp", title: "Kochar Destination Itinerary" },
    { id: "lotus-welcome", img: "/images/portfolio/lotus-wedding-welcome-suite.webp", title: "Lotus Welcome Suite · Udaipur" },
  ],
  "Luggage Tags": [
    { id: "luggage-cutout", img: "/images/portfolio/destination-wedding-luggage-tags.webp", title: "Destination Luggage Tag Set" },
    { id: "cutout-itinerary-cat", img: "/images/portfolio/couple-cutout-wedding-itinerary.webp", title: "Couple Cutout Itinerary Tags" },
  ],
  "Caricature Cards": [
    { id: "suitcase-pair", img: "/images/portfolio/caricature-wedding-luggage-tags.webp", title: "Couple Suitcase Caricatures" },
  ],
  "Hamper Tags": [
    { id: "carriage-box-cat", img: "/images/portfolio/wedding-invitation-box-carriage.webp", title: "Carriage Box Suite" },
  ],
  "Tent Cards & Itinerary": [
    { id: "timeline-illustrated", img: "/images/portfolio/wedding-itinerary-card-illustrated.webp", title: "Illustrated Wedding Timeline" },
  ],
  "Save the Dates & E-Invites": [
    { id: "petal-cones-cat", img: "/images/portfolio/monogrammed-petal-toss-cones.webp", title: "Rose Petal Toss Cones" },
    { id: "welcome-itinerary-cat", img: "/images/portfolio/destination-wedding-welcome-card.webp", title: "Welcome & Itinerary Card" },
  ],
};

export const TIME_SLOTS = [
  "10:00 AM", "11:00 AM", "12:00 PM",
  "02:00 PM", "03:00 PM", "04:00 PM",
  "05:00 PM", "06:00 PM",
];

export const MEETING_TOPICS = [
  "Luggage Tags",
  "Caricature Luggage Tags",
  "Hamper Tags & Door Danglers",
  "Tent Cards",
  "Delhi NCR · 24-Hour Express",
  "General Wedding Enquiry",
];

export const MEETING_MODES = [
  {
    id: "video",
    label: "Google Meet",
    sub: "Virtual · 30-minute video consultation",
    icon: "video",
  },
  {
    id: "office",
    label: "Visit Our Studio",
    sub: `In-person · ${OFFICE_ADDRESS.line1}, ${OFFICE_ADDRESS.line2}`,
    icon: "office",
  },
];
